import { IActivityUpdateRequest } from "@wingspanhq/users";
import { queryCache } from "react-query";
import { usersService } from "../services/users";
import { useWSMutation } from "./helpers";
import { QUERY_USERS_ACTIVITIES } from "./users/keys";

export const useUpdateActivity = (userId: string) =>
  useWSMutation(
    (request: IActivityUpdateRequest) =>
      usersService.activity.update(userId, request),
    {
      onSuccess: async () => {
        await queryCache.refetchQueries(QUERY_USERS_ACTIVITIES);
      }
    }
  );
